import {
  vArray,
  vBoolean,
  vEmail,
  vFormattedPhoneNumber,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'
import {
  type CredentialDetail,
  credentialDetailSchema,
} from './account-carrier.ts'
import type { ProvisionerLocationDto } from './account-provisioning.ts'

interface CarrierConnectionBase {
  carrierId: string
  carrierName: string
  enableLTL: boolean
  enableParcel: boolean
  enableTL: boolean
}
export interface CarrierConnectionDto extends CarrierConnectionBase {
  supportsApi: boolean
  isApiIntegrated: boolean
  hasSpotContacts: boolean
  isPending: boolean
  needsAttention: boolean
  spotContactCount: number
  scac?: string
}

export interface CarrierConnectionSalesRep {
  firstName?: string
  lastName?: string
  phone?: string
  emails: string[]
}

export interface SpotContactDto {
  userId: string
  email: string
  name?: string
  groups?: string[]
}

export interface CarrierConnectionDetailsDto extends CarrierConnectionBase {
  salesRep?: CarrierConnectionSalesRep
  credentials?: CredentialDetail[]
  locations?: ProvisionerLocationDto[]
  spotContacts?: SpotContactDto[]
  isBeta?: boolean
}

export const upsertCarrierConnectionSalesRepSchema = vObject({
  firstName: vOptional(vString()),
  lastName: vOptional(vString()),
  phone: vOptional(vFormattedPhoneNumber()),
  emails: vOptional(vArray(vEmail)),
})

export type UpsertCarrierConnectionSalesRep = vOutput<
  typeof upsertCarrierConnectionSalesRepSchema
>

export const upsertCarrierConnectionSchema = vObject({
  carrierId: vObjectId(),
  salesRep: vOptional(upsertCarrierConnectionSalesRepSchema),
  credentials: vOptional(vArray(credentialDetailSchema)),
  spotEmails: vOptional(vArray(vEmail)),
  enableLTL: vOptional(vBoolean()),
  enableParcel: vOptional(vBoolean()),
  enableTL: vOptional(vBoolean()),
  isOnboarding: vOptional(vBoolean()),
})

export type UpsertCarrierConnectionDto = vOutput<
  typeof upsertCarrierConnectionSchema
>
